import React from "react";
import { useNavigate } from "react-router-dom";
import { Brand, Eyebrow } from "@/components/brand";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  const sections = [
    { title: "1. Information We Collect", content: "Equal AI collects information you provide directly when using our cannabis equity advisory platform. This includes your email address, authentication information, conversation history and messages exchanged with our AI consultant, session data including timestamps and interaction patterns, and information you provide about your cannabis equity application." },
    { title: "2. How We Use Your Information", content: "We use collected information to provide AI-powered cannabis equity advisory services, improve our AI accuracy and knowledge base, share session transcripts with City of Long Beach officials as required for transparency and compliance, send important updates and notifications, and maintain platform functionality and security." },
    { title: "3. Information Sharing & Transparency", content: "Your conversation sessions are automatically shared with City of Long Beach officials for transparency and compliance purposes. This is a requirement of the cannabis equity program. We also share with service providers (cloud infrastructure, AI services) and as required by law.", highlight: true },
    { title: "4. Data Security", content: "We implement industry-standard security measures including encrypted data transmission (HTTPS/TLS), secure password hashing, regular security audits, and access controls and authentication requirements." },
    { title: "5. Your Rights", content: "You have the right to access your conversation history and personal data, request corrections to your information, delete your account and associated data, and opt-out of non-essential communications." },
    { title: "6. Contact Us", content: "For questions about this Privacy Policy: yan@tkachventures.com · Equal AI - Cannabis Equity Advisory Platform" },
  ];

  return (
    <div className="min-h-screen bg-page">
      <header className="h-14 bg-white border-b border-line px-5 md:px-8 flex items-center">
        <Brand onClick={() => navigate("/")} />
      </header>
      <div className="bg-mint border-b border-[#cfe9db]">
        <div className="max-w-3xl mx-auto px-5 md:px-8 py-14">
          <Eyebrow className="text-equal-dark mb-3">Legal</Eyebrow>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-ink tracking-tight leading-[1.05] mb-3">Privacy Policy</h1>
          <p className="text-mute text-sm font-mono">Last Updated: April 29, 2026</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-12">
        <div className="card-flat p-7 md:p-10 space-y-9 text-ink-2 text-sm leading-relaxed">
          {sections.map((s, i) => (
            <div key={s.title} className="grid sm:grid-cols-[40px_1fr] gap-3">
              <span className="font-mono text-[11px] text-mute pt-1">{String(i + 1).padStart(2, "0")}</span>
              <div>
                <h2 className="text-ink font-bold text-base tracking-tight mb-2">{s.title}</h2>
                {s.highlight && (
                  <div className="mb-3 p-3 rounded-[10px] bg-warm border border-[#f3d9b0] text-[#7a4b0a] text-xs">
                    Important: Sessions are shared with City of Long Beach officials as part of the cannabis equity program.
                  </div>
                )}
                <p>{s.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
